import styled from 'styled-components'

import { Box } from '@/atoms/layout'

const StyledComment = styled(Box)<{ $hasError?: boolean }>`
  border: 1px solid ${({ theme, $hasError }) => ($hasError ? theme.colors.error : theme.colors.greyLight)};
  padding: ${({ theme }) => `${theme.space.S4} ${theme.space.S8}`};
`

export default StyledComment
